import css from 'styled-jsx/css'

// Theme
import { colors } from '@/theme/colors'

export const globalStyles = css.global`
  @import url('https://rsms.me/inter/inter.css');
  @import url('https://fonts.googleapis.com/css?family=Be Vietnam');
  html {
    font-family: 'Inter', 'Be Vietnam', sans-serif;
  }
  @supports (font-variation-settings: normal) {
    html {
      font-family: 'Inter var', 'Be Vietnam', sans-serif;
    }
  }
  body {
    color: ${colors.dark};
    background-color: ${colors.secondary} !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow-y: auto !important;
    font-size: 0.875rem;
  }
  * {
    font-family: 'Inter', 'Be Vietnam', sans-serif;
  }

  /* width */
  body::-webkit-scrollbar {
    background-color: transparent;
    border-radius: 5px;
    height: 10px;
    transition: background-color 0.2s linear;
    width: 10px; /* Tamaño del scroll en horizontal */
  }

  body::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  body::-webkit-scrollbar-thumb {
    webkit-border-radius: 5px;
    background: #aaa;
    background-clip: padding-box;
    border: 2px solid transparent;
    border-radius: 5px;
    transition: background-color 0.2s linear;
  }
  /* -- customs global classes -- */
  .d-flex {
    display: flex;
  }

  .center-element {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .items-right {
    justify-content: flex-end;
  }
  .items-left {
    justify-content: flex-start;
  }
  .items-space-between {
    justify-content: space-between;
  }
  .mb-2 {
    margin-bottom: 2rem !important;
  }
  .mb-4 {
    margin-bottom: 4rem !important;
  }
  .mt-1 {
    margin-top: 1rem !important;
  }
  .mt-2 {
    margin-top: 2rem !important;
  }
  .pd-0 {
    padding: 0 !important;
  }
  .w-100 {
    width: 100% !important;
  }
  .w-75 {
    width: 75% !important;
  }
  .w-50 {
    width: 50% !important;
  }
  .bg-light {
    background-color: #f9fafb !important;
  }
  .bg-white {
    background-color: #fff !important;
  }
  .h-auto {
    height: auto !important;
  }

  .btn-danger {
    background-color: #fee2e2 !important;
    color: #b91c1c !important;
    transition: 0.3s all ease;
  }

  .btn-danger:hover {
    opacity: 0.8;
  }

  /* Titles */

  .page-title {
    font-weight: 500;
  }
  .page-title-v2 {
    font-weight: 500;
    margin-top: 0;
  }
  .page-subtitle {
    font-weight: 400;
    color: #6b7280;
  }

  .header-title {
    font-family: 'Inter', 'Be Vietnam', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    margin: 0px 0px;
  }

  .header-subtitle {
    position: static;
    font-family: 'Inter', 'Be Vietnam', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #6b7280;
    margin: 0px 0px;
  }

  .header-divider {
    margin: 20px 0px;
  }

  .header-divider-big {
    margin: 40px 0px;
  }

  .form-label {
    font-family: 'Inter', 'Be Vietnam', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #374151;
  }

  .MuiOutlinedInput-input {
    font-family: 'Inter', 'Be Vietnam', sans-serif;
    font-size: 14px !important;
    padding: 14px 12px !important;
    font-style: normal;
    font-weight: normal;
    color: #6b7280;
  }

  .MuiOutlinedInput-input:disabled {
    font-family: 'Inter', 'Be Vietnam', sans-serif;
    font-size: 14px !important;
    padding: 14px 12px !important;
    font-style: normal;
    font-weight: normal;
    color: #272b30;
  }

  .datepicker_sp {
    border: 1px solid rgba(0, 0, 0, 0.23) !important;
    border-radius: 7px !important;
  }

  .datepicker_sp input {
    font-size: 14px !important;
    padding: 13px 12px !important;
    font-style: normal;
    font-weight: normal;
    color: #6b7280;
  }

  .confirm-modal.modal-response .MuiDialog-paper button {
    text-transform: none !important;
  }

  .MuiDialog-paper button {
    text-transform: none !important;
  }

  /* .datepicker_sp .MuiInput-underline:before, .datepicker_sp .MuiInput-underline:after{
    display: none !important;
  } */

  .MuiOutlinedInput-root {
    border-radius: 7px !important;
  }

  .MuiOutlinedInput-root.form-input {
    margin-bottom: 15px !important;
  }

  .MuiButton-root {
    box-shadow: 0px 1px 2px rgb(0 0 0 / 5%) !important;
    border-radius: 6px !important;
    text-transform: capitalize !important;
    font-weight: 400 !important;
    padding: 6px 20px !important;
  }

  .MuiButton-containedPrimary {
    color: #fff !important;
  }

  .MuiButton-containedPrimary:not(.Mui-disabled) {
    border: 1px solid #0047ba !important;
  }

  .MuiInput-root.sp-select {
    border: 1px solid rgba(0, 0, 0, 0.23) !important;
    border-radius: 7px !important;
  }

  .MuiSelect-select:focus {
    background-color: #fff !important;
    border: none;
    border-radius: 7px !important;
  }
  .MuiInput-root.sp-select:hover {
    background-color: #fff !important;
    border: 1px solid rgb(62, 95, 88) !important;
    border-radius: 7px !important;
  }

  .MuiInput-root.sp-select.Mui-disabled:hover {
    background-color: #eeeeee !important;
    border: none !important;
    border: 1px solid rgba(0, 0, 0, 0.23) !important;
  }

  .MuiInput-root.sp-select.Mui-focused {
    background-color: #fff;
    border: 2px solid rgb(62, 95, 88) !important;
    border-radius: 7px !important;
  }

  .MuiInput-root.sp-select:before,
  .MuiInput-root.sp-select.Mui-focused:after {
    display: none;
  }

  .MuiInput-root.sp-select .MuiSelect-select {
    /* padding: 13px 26px 13px 13px; */
    padding: 12px 26px 11px 13px;
  }

  .MuiListItem-root.Mui-selected,
  .MuiListItem-root.Mui-selected:hover {
    background-color: rgba(132, 165, 158, 0.2) !important;
  }

  .MuiInput-underline.Mui-error {
    border: 1px solid #f44336 !important;
  }

  .MuiInput-underline.Mui-error:after {
    display: none !important;
  }

  .form-button-margin {
    margin: 0px 5px !important;
  }

  .input-helper-text {
    margin-left: 0px !important;
    font-size: 12px !important;
    line-height: 20px !important;
    margin-top: 8px !important;
  }

  .loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    justify-content: center;
    background-color: #fff;
    padding-top: calc(100vh / 2 - 20px);
  }
  .loader .white-box {
    display: flex;
    justify-content: center;
  }

  /* Styles for Structure Details Component */
  :global(.MuiGrid-root.MuiGrid-item.bg-form) {
    box-shadow: 5px 5px 5px rgb(145 158 171 / 5%);
    background: #f3f7f6;
    padding: 0 20px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    height: max-content;
    overflow: hidden;
  }

  /* sticky para mas adelante */
  /* :global(.MuiGrid-root.MuiGrid-item.bg-form.structure-sticky) {
    position: sticky;
    top: 90px;
  } */

  :global(.base-link) {
    color: #0047ba;
    text-decoration: none;
    font-weight: 500;
  }
  :global(.base-link:hover) {
    text-decoration: underline;
  }
  @media (hover: none) {
    :global(.base-link) {
      text-decoration: underline;
    }
  }

  .MuiInputBase-root.Mui-disabled {
    background-color: #eeeeee !important;
  }

  :global(.MuiGrid-root.MuiGrid-item.bg-form.structure) {
    padding: 20px 20px 0 20px;
  }

  :global(.structure-details) {
    padding-right: 3rem;
  }

  .no-image {
    width: 100% !important;
    height: 100% !important;
    background: #eeeeee;
    color: black;
    margin: 0;
    border-radius: 8px;
  }

  .center-errors {
    position: absolute;
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    right: 0;
  }

  .MuiFormControlLabel-label.Mui-disabled {
    color: #6b7280 !important;
  }

  @media (max-width: 960px) {
    :global(.structure-details) {
      padding-right: 1rem;
    }

    .MuiButton-containedPrimary {
      color: #fff !important;
      width: 40%;
    }

    .MuiButton-containedPrimary:not(.Mui-disabled) {
      border: 1px solid #0047ba !important;
      width: 40%;
    }

    .MuiButton-outlined {
      border: 1px solid rgba(0, 0, 0, 0.23);
      padding: 5px 15px;
      width: 40%;
    }

    :global(.custom-buttons-w-auto > *) {
      width: auto !important;
    }

    :global(.custom-buttons-modal > *) {
      width: 90% !important;
      margin-left: 0 !important;
      margin-top: 10px !important;
    }
    :global(.custom-buttons-modal-cancel > *) {
      width: 40% !important;
      margin-top: 10px !important;
    }
    :global(.custom-buttons > *) {
      width: 40% !important;
      margin-left: 0 !important;
    }
  }
  .MuiGrid-item.mt-noresponsive {
    margin-top: 2rem;
  }
  @media (max-width: 710px) {
    h4.page-title {
      margin-bottom: 10px !important;
    }
  }
  @media (max-width: 600px) {
    :global(.structure-details) {
      padding-right: 0 !important;
    }
    :global(.structure-sticky) {
      margin-top: 2rem !important;
    }
    .MuiGrid-item.mt-noresponsive {
      margin-top: 0;
    }
    h4.page-title {
      margin-bottom: 10px !important;
    }
    p.page-subtitle {
      margin-bottom: 15px !important;
    }
    p.page-subtitle.name-renter {
      margin-bottom: 0 !important;
      margin-top: 0px !important;
    }
    p.page-subtitle.name-renter.renter-name {
      margin-bottom: 0 !important;
      margin-top: 0px !important;
    }
    :global(.custom-buttons > *) {
      width: 40% !important;
      margin-left: 0 !important;
      margin-top: 10px !important;
    }
    :global(.custom-buttons-modal > *) {
      width: 90% !important;
      margin-left: 0 !important;
      margin-top: 10px !important;
    }
    :global(.custom-buttons-modal-cancel > *) {
      width: 100% !important;
      margin-top: 10px !important;
    }
    :global(.amount-text) {
      position: relative;
      height: 20px;
      top: 5px !important;
      margin: auto;
      text-align: right;
    }
    :global(.amount-text-cash) {
      position: relative;
      height: 20px;
      top: -5px !important;
      margin: auto;
      text-align: right;
    }
  }

  @media (max-width: 700px) {
    .center-element-responsive {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    :global(.custom-buttons-modal > *) {
      width: 100% !important;
      margin-left: 0 !important;
      margin-top: 10px !important;
    }
    :global(.custom-buttons-modal-cancel > *) {
      width: 100% !important;
      margin-top: 10px !important;
    }
  }

  @media (min-width: 700px) {
    .center-element-responsive {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  :global(.MuiInput-root.view-mode:hover),
  :global(.MuiInput-root.view-mode),
  :global(.MuiInput-root.sp-select.Mui-focused.view-mode) {
    outline: none !important;
    border: 1px solid rgba(0, 0, 0, 0.23) !important;
  }
  :global(.MuiInput-root.view-mode *) {
    cursor: default !important;
  }
  .dzu-dropzoneActive {
    background-color: #d7e9e4 !important;
  }
  :global(.disabledSwitch span:nth-child(1)) {
    opacity: 0.7;
  }
  :global(.displayInline) {
    display: inline;
  }
  :global(.MuiTooltip-tooltip) {
    font-size: 12px !important;
  }
`
